import {
  createContext,
  useContext,
  useMemo,
  type FC,
  type ReactNode,
} from 'react';

import { useParams } from 'react-router-dom';

interface SandboxContextType {
  selectedSandbox: string;
  gameCode: string;
}

const SandboxContext = createContext<SandboxContextType | undefined>(undefined);

interface SandboxProviderProps {
  children: ReactNode;
}

export const SandboxProvider: FC<SandboxProviderProps> = ({ children }) => {
  const { gameId, sandboxId } = useParams<{
    gameId: string;
    sandboxId: string;
  }>();

  const value = useMemo<SandboxContextType>(
    () => ({
      selectedSandbox: sandboxId!,
      gameCode: gameId!,
    }),
    [sandboxId, gameId],
  );

  return (
    <SandboxContext.Provider value={value}>{children}</SandboxContext.Provider>
  );
};

export const useSandboxContext = (): SandboxContextType => {
  const context = useContext(SandboxContext);
  if (context === undefined) {
    throw new Error('useSandboxContext must be used within a SandboxProvider');
  }
  return context;
};
